import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import DatosUsuario from './perfil_usuario/DatosUsuario';
import React from 'react';
import { LoginDatos } from '@/objects/User';
import { cargarDatosUsuario, removeUserData } from '@/util/LocalStorageLoaded';
import PassUsuario from './perfil_usuario/PassUsuario';
import Boton from '@/components/elements/Boton';
import { mostrarAlerta } from '@/context/UtilsContext';
import { rojoerror, white } from '@/constants/Colors';
import DeleteIcon from '@mui/icons-material/Delete';
import { useServices } from '@/context/ServicesProvider';
import DatosEmailGeneral from './perfil_usuario/DatosEmailGeneral';
import DatosEmailChat from './perfil_usuario/DatosEmailChat';
import DatosAlertas from './perfil_usuario/DatosAlertas';
import DatosMostrarMapa from './perfil_usuario/DatosMostrarMapa';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
function PerfilUsuario() {

    const { t } = useTranslation();

    const { usersQueries } = useServices();

    const [datosUsuario, setDatosUsuario] = React.useState<LoginDatos | null>();

    React.useEffect(() => {
        setDatosUsuario(cargarDatosUsuario()!);
    }, []);

    function borrarCuenta() {
        //Borrar la cuenta del usuario
        mostrarAlerta({
            title: t('common:opciones.informacion'),
            content: t("menu:secciones.ajustes_perfil.borrar_cuenta_confirmacion"),
            showCancelButton: true,
            cancelText: t('common:opciones.cancelar'),
            acceptText: t('common:opciones.borrar'),
            onAccept: () => {

                const datosUsuario: LoginDatos = cargarDatosUsuario()!;
                //Borrar la cuenta
                usersQueries?.darDeBaja(datosUsuario.id_user).then((response) => {
                    if (response.status === 200) {
                        removeUserData();
                        //Carga pagina principal
                        window.location.href = "/";
                    }
                });
            }
        });
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', alignContent: "center", alignItems: "center" }}>
            <TituloPrincipalH1 texto={t("menu:secciones.ajustes_perfil.titulo")} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px', width: "93%" }}>
                <DatosUsuario datosUsuario={datosUsuario!} setDatosUsuario={setDatosUsuario!} />
                <DatosEmailGeneral datosUsuario={datosUsuario!} setDatosUsuario={setDatosUsuario!} />
                <DatosEmailChat datosUsuario={datosUsuario!} setDatosUsuario={setDatosUsuario!} />
                <DatosAlertas datosUsuario={datosUsuario!} setDatosUsuario={setDatosUsuario!} />
                <DatosMostrarMapa datosUsuario={datosUsuario!} />
                <PassUsuario />
                <Boton startIcon={<DeleteIcon />} color={rojoerror} colorTexto={white} texto={t("menu:secciones.ajustes_perfil.borrar_cuenta")} onClick={() => { borrarCuenta() }} />
            </div>
        </section>
    );
}

export default PerfilUsuario;